<script>
export default {
  name: 'upload-btn',
  props: {
    multiple: { type: Boolean, default: true },
    accept: { type: String }
  },
  data: () => ({
    files: null
  }),
  methods: {
    onClick () {
      this.$refs['__file_input__'].click()
    },
    onFilesSelected (event) {
      this.$emit('input', event.target.files)
    }
  }
}
</script>
<template>
  <div>
    <b-btn v-bind="$attrs" v-on:click="onClick"
      ><div class="d-flex align-items-center">
        <slot>Upload</slot>
      </div>
    </b-btn>
    <input
      type="file"
      class="d-none"
      ref="__file_input__"
      :multiple="multiple"
      :accept="accept"
      v-on:change="onFilesSelected"
    />
  </div>
</template>
